import { cloneDeep, findIndex } from 'lodash'
import {
  ADD_SLATE,
  DELETE_SLATE,
  UPDATE_SLATE,
  UPDATE_SLATE_WIDGET_GRID,
  SET_SLATE_CONFIG,
  ADD_SLATE_WIDGET,
  DELETE_SLATE_WIDGET,
  UPDATE_SLATE_WIDGET,
  UPDATE_SLATE_GRID,
  UPDATE_SLATE_WIDGET_GRID_LAYOUT,
  SET_UNSAVED_SLATE_CHANGES,
  SWAP_SLATE_WIDGET,
} from '../../constants/types'


export const Reducer = (state = {}, { type, payload = {} }) => {
  switch (type) {
  case ADD_SLATE:
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.id]: {
          ...payload,
          height: 'half',
        },
      },
    }
  case DELETE_SLATE: {
    const newSlates = cloneDeep(state)
    delete newSlates[payload.report_type][payload.id]
    return { ...newSlates }
  }
  case UPDATE_SLATE: {
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.id]: {
          ...state[payload.report_type][payload.id],
          ...payload.update,
        },
      },
    }
  }
  case UPDATE_SLATE_WIDGET_GRID: {
    const newWidgetGrid = cloneDeep(payload.widgets)
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.id]: {
          ...state[payload.report_type][payload.id],
          widgets: [
            ...newWidgetGrid,
          ],
        },
      },
    }
  }
  case SET_SLATE_CONFIG: {
    return payload
  }
  case ADD_SLATE_WIDGET: {
    const { newWidget } = payload
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.slate_id]: {
          ...state[payload.report_type][payload.slate_id],
          widgets: [
            ...state[payload.report_type][payload.slate_id].widgets,
            newWidget,
          ],
        },
      },
    }
  }
  case SET_UNSAVED_SLATE_CHANGES: {
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.slate_id]: {
          ...state[payload.report_type][payload.slate_id],
          unsavedChanges: payload.value,
        },
      },
    }
  }
  case DELETE_SLATE_WIDGET: {
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.slate_id]: {
          ...state[payload.report_type][payload.slate_id],
          widgets: state[payload.slate_id].widgets.filter((w) => w.id !== payload.id),
        },
      },
    }
  }
  case UPDATE_SLATE_WIDGET: {
    const { widgets } = state[payload.report_type][payload.slate_id]
    const widgetClone = cloneDeep(widgets[payload.index])
    widgets[payload.index] = {
      ...widgetClone,
      ...payload.update,
    }
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.slate_id]: {
          ...state[payload.report_type][payload.slate_id],
          widgets: [
            ...widgets,
          ],
        },
      },
    }
  }
  case UPDATE_SLATE_GRID: {
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.slate_id]: {
          ...state[payload.report_type][payload.slate_id],
          layout: payload.config.layout,
          widgets: [
            ...payload.config.widgets,
          ],
        },
      },
    }
  }
  case UPDATE_SLATE_WIDGET_GRID_LAYOUT: {
    const newWidgetConfig = cloneDeep(payload.newOrder)
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.slate_id]: {
          ...state[payload.report_type][payload.slate_id],
          widgets: [
            ...newWidgetConfig,
          ],
        },
      },
    }
  }
  case SWAP_SLATE_WIDGET: {
    // EDIT THIS HERE ...
    const { widgets, layout } = state[payload.report_type][payload.slate_id]
    payload.newWidget.width = widgets.find((w) => w.id === payload.widget_id).width
    const widgetIndex = findIndex(widgets, (w) => w.id === payload.widget_id)
    const newWidgets = cloneDeep(widgets)
    newWidgets.splice(widgetIndex, 1, payload.newWidget)
    const newLayout = cloneDeep(layout)
    const originalSize = newLayout[payload.rowNum][payload.colNum].cellSize
    newLayout[payload.rowNum]
      .splice(payload.colNum, 1, { id: payload.newWidget.id, cellSize: originalSize })
    return {
      ...state,
      [payload.report_type]: {
        ...state[payload.report_type],
        [payload.slate_id]: {
          ...state[payload.report_type][payload.slate_id],
          widgets: newWidgets,
          layout: newLayout,
        },
      },
    }
  }
  default:
    return state
  }
}
